/* ICONS */
import { TbNotebook } from "react-icons/tb";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaUniversity,
} from "react-icons/fa";

const navMenu = [
  {
    id: 1,
    link: "/student",
    icon: FaUserGraduate,
    name: "Student Forms",
  },
  {
    id: 2,
      link: "/teacher",
    icon: FaChalkboardTeacher,
    name: "Teacher Forms",
  },
  {
    id: 3,
    link: "/institute",
    icon: FaUniversity,
    name: "Institute Forms",
  },
];

export default navMenu;
